export default class ApiState{
    constructor({data = null, error = null} = {data:null, error:null}) {
        this.success = data
        this.error = error
    }
}